import { breakpoints } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { SidebarMenu } from '../../../../SidebarMenu';
export const StyledSidebarMenu = styled(SidebarMenu) `
  display: none;

  ${breakpoints.md} {
    display: flex;
  }
`;
